import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { Message } from "element-ui"; // 导入 Message
import "./assets/iconfont.css";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(utc)
dayjs.extend(timezone)
// 服务器时间统一按美国东部时区解析
dayjs.tz.setDefault('America/New_York')
Vue.prototype.$dayjs = dayjs
// import * as echarts from 'echarts'
// Vue.prototype.$echarts = echarts

// 全局挂载 Message 到 Vue 原型
Vue.prototype.$message = Message;

Vue.config.productionTip = false;
Vue.use(ElementUI);

//api
import api from "./api";
Vue.prototype.$api = api;

//i18n
import i18n from "./locales";

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
